import Header from "component/layout/header/Header";
import AuthUser from "component/molecules/users/single-user/components/authentication/AuthUser";
import UserDetails from "component/molecules/users/single-user/components/details/UserDetails";
import React from "react";
import UserProfileTemplate from "component/organism/single-user/UserProfileTemplate";
const UserProfile = () => {
  return (
    <>
      <Header title="User Profile" isBack />
      <UserProfileTemplate />
    </>
  );
};

export default UserProfile;
